export const isMobile = () => {
  return environment.isBrowser && environment.isMobile;
};
